import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const ActionLog = (props) => {
  const {
    actionLog,
  } = props;
  const sortedActionLog = [...actionLog].sort((firstLog, secondLog) => {
    const firstCreatedAt = new Date(firstLog.createdAt).getTime();
    const secondCreatedAt = new Date(secondLog.createdAt).getTime();

    return firstCreatedAt - secondCreatedAt;
  });

  return (
    <Stack gap={1.5}>
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 700,
          lineHeight: '20px',
          color: '#050A14',
          textDecoration: 'underline',
          textDecorationColor: '#050A14',
          textUnderlineOffset: '3px',
        }}
      >
        <Translate expression='case.Detail.ActionLog.Title' />
      </Typography>
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          border: '1px solid #ECECF1',
          borderRadius: '10px',
          overflow: 'hidden',
        }}
      >
        {
          sortedActionLog.length === 0 && (
            <Typography
              sx={{
                px: 3,
                py: 2,
                fontSize: '12px',
                color: '#9A9BAE',
              }}
            >
              <Translate expression='case.Detail.ActionLog.Empty' />
            </Typography>
          )
        }
        {
          sortedActionLog.map((actionLogEntry, index) => {
            const createdAtDate = new Date(actionLogEntry.createdAt);
            const createdAtLabel = Number.isNaN(createdAtDate.getTime()) ?
              '' :
              createdAtDate.toLocaleString([], {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
              });

            return (
              <Stack
                key={`${actionLogEntry.createdAt}-${index}`}
                gap={1}
                sx={{
                  px: 3,
                  py: 2.5,
                  borderBottom: index === sortedActionLog.length - 1 ? 'none' : '1px solid #ECECF1',
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#9A9BAE',
                  }}
                >
                  {createdAtLabel}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#050A14',
                    lineHeight: '20px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}
                >
                  {actionLogEntry.message}
                </Typography>
              </Stack>
            );
          })
        }
      </Box>
    </Stack>
  );
};

ActionLog.propTypes = {
  actionLog: PropTypes.array.isRequired,
};

export default React.memo(ActionLog);
